// SolyticsInputToggleSwitch.jsx
// @ts-nocheck
/* eslint-disable react/prop-types */
import React from 'react';
import { Switch, styled, FormControlLabel } from '@mui/material';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common?.white,
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary?.main,
        opacity: 1,
        border: 0,
        ...theme.applyStyles('dark', {
          backgroundColor: theme.palette.primary?.main,
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: theme.palette.primary?.main,
      border: `6px solid ${theme.palette.common?.white}`,
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600],
      }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3,
      }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: '16px !important',
    height: '16px !important',
    border: 'none !important',
    boxShadow: theme.shadows[1],
  },
  '& .MuiSwitch-track': {
    borderRadius: '12px !important',
    width: '36px !important',
    height: '20px !important',
    backgroundColor: theme.palette.grey?.[50],
    opacity: '1 !important',
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey?.T60,
    }),
  },
}));

/**
 * SolyticsInputToggleSwitch - An iOS-style toggle switch component
 *
 * @component
 * @description
 * SolyticsInputToggleSwitch is a styled toggle switch component based on Material-UI's Switch,
 * designed with iOS-style aesthetics. It provides a customizable on/off control with smooth
 * animations and full accessibility support.
 *
 * @param {string} label - Label text displayed next to the toggle switch
 * @param {boolean} value - Controlled value state of the switch (checked/unchecked, default: false)
 * @param {function} onChange - Callback function when switch state changes (receives boolean value)
 * @param {boolean} disabled - If true, the switch is disabled and cannot be toggled (default: false)
 * @param {boolean} required - If true, marks the switch as required in forms
 * @param {string} id - HTML id attribute for the switch element
 * @param {string} name - Name attribute for the switch (required for form submission)
 * @param {boolean} labelLeft - If true, label appears before the switch (default: false)
 *
 * @returns {React.ReactElement} A toggle switch element with label
 */
const SolyticsInputToggleSwitch = ({
  label,
  value = false,
  onChange,
  disabled = false,
  required,
  id,
  name,
  labelLeft = false,
}) => {
  if (!name || !onChange) return null;
  return (
    <FormControlLabel
      {...(disabled && { disabled })}
      {...(required && { required })}
      labelPlacement={labelLeft ? 'start' : 'end'}
      control={
        <IOSSwitch
          checked={value}
          {...(onChange && { onChange: (e) => onChange?.(e.target.checked) })}
          {...(disabled && { disabled })}
          {...(id && { id })}
          name={name}
        />
      }
      {...(label && { label })}
      sx={{
        // Reset default MUI negative margins
        marginLeft: 0,
        // Reset default MUI negative margins
        marginRight: 0,
        ...(labelLeft ? { marginRight: '8px' } : { marginLeft: '8px' }),
        '& .MuiFormControlLabel-label': labelLeft
          ? { marginRight: '8px' }
          : { marginLeft: '8px' },
      }}
    />
  );
};

export default SolyticsInputToggleSwitch;
